module.exports = __webpack_public_path__ + "static/media/akali-lose.4c1590a4.png";